import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useRef, useState } from "react";
import { HiPencil } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { getUserRole } from "../../../CommonFunction/GetUserInfo";
import { ClearSpecificForm } from "../../../Store/FormDataReducer/FormFieldFunctions";
import {
  defaultSettingOfColumns,
  editTableColumnManagementLabels,
  getFields,
  updateOrder,
} from "../../../Utils/AllPagesQuriesAndMutations";
import Button from "../Button/Button";
import { FormInputSectionComponent } from "../FormInputSectionComponent/FormInputSectionComponent";
import { updateValueForm } from "../FormInputSectionComponent/formUtils";
import Loading from "../Loading/Loading";
import { useModalContext } from "../Reactportal/ModalContext";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../ToastComponent/RectHotToast";
import { getColumnFields } from "./columnManagement.config";
import "./ColumnManagement.scss";

// ----------------------
// react-beautiful-dnd imports
// ----------------------
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import { Confirm } from "../Confirmation/Confirm";

// ----------------------
// TypeScript Interfaces
// ----------------------
interface field {
  Field_Label: string;
  Field_Name: string;
  _id: string;
}

interface typeOfData {
  Field_Name: string;
  Serial_No: number;
  Status: any;
  _id: string;
  Table_ColumnManagement_Id: any;
  Field_Label?: string;
  Licensee_FieldMaster_Id: any;
  Table_View: boolean;
  Field_Id: field;
  Table_Column_Name?: string;
  Field_Type?: string;
  Column_Total: boolean;
  Table_Id: field
}

// ----------------------
// GraphQL Queries/Mutations
// ----------------------

export const ColumnManagement = ({ show, Closeformfunction, title }) => {
  const [FormData, setFormdata] = useState({});
  const formRef = useRef({});
  const Form_Key = "Table_Column_Management";
  const [UpdateOrder, { loading }] = useMutation(updateOrder);
  const [ColumnData, setColumnData] = useState<typeOfData[] | null>(null);
  const { getTopKey } = useModalContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [defaultSettings, setDefaultSettings] = useState(true);
  const [selectedColumn, setSelectedColumn] = useState<typeOfData | null>(null);
  console.log(ColumnData, 'ColumnDataColumnData');
  const dispatch = useDispatch();
  const column = useSelector((store: any) => store.ColumnManagementReducer);
  const rights = useSelector((state: any) => state.userRightsReducer.userRightsData);
  const [userRoleAuth, setUserRoleAuth] = useState(false);
  const [ApplyToAll, setApplyAll] = useState(true);
  const [confirmModalstate, setConifrmModalState] = useState(false);
  const [IsSuperAdminChange, setIsSuperAdminChange] = useState(true);
  const path = window.location.pathname;
  const myCounterRef = useRef(0);
  let topModel = getTopKey();

  // Q & M
  const [getCurrentField] = useLazyQuery(getFields, {
    fetchPolicy: "network-only",
  });

  // Default Setting Mutation
  const [DefaultSetting, { loading: DefaultLoading }] = useMutation(defaultSettingOfColumns);

  // Edit Table Column
  const [editTableColumn, { loading: editTableColumnLoading }] = useMutation(editTableColumnManagementLabels, {
    fetchPolicy: "network-only",
  });

  const tableColumnManagementLoading = editTableColumnLoading;

  useEffect(() => {
    let Path = rights[path];

    // if (path.includes("/Ledger/") || path.includes("/Account_Vouchers/")) {
    //   Path = rights["/Ledger"];
    // }
    // if (path.includes("/Monthly_Ledger_Data/")) {

    //   Path = rights["/Ledger"];
    // }
    // if (path.includes("/Receivable/NewRef/")) {
    //   Path = rights["/ReceivableBillByBill"];
    // }
    // if (path.includes("/Payable/NewRef/")) {
    //   Path = rights["/PayableBillByBill"];
    // }
    // if (path.includes("/Receivable_Account_Bill_By_Bill_Detail_View/")) {
    //   Path = rights["/ReceivableBillByBill"];
    // }
    // if (path.includes("/Payable_Account_Bill_By_Bill_Detail_View/")) {
    //   Path = rights["/PayableBillByBill"];
    // }
    // console.log(Path?.Page_Id, "Path?.Page_IdPath?.Page_IdPath?.Page_Id")
    // if (Path?.Page_Id) {
    getCurrentField({
      variables: {
        Table_Key: title || topModel,
      },
    }).then((res) => {
      setColumnData(res?.data?.GetUserTableColumnManagementWithUserId_Page_ID);
    });
    // }
  }, [rights, path]);

  // -----------------------------
  // Reorder helper for drag & drop
  // -----------------------------
  const reorder = (list: typeOfData[], startIndex: number, endIndex: number): typeOfData[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // -----------------------------
  // onDragEnd - React Beautiful DnD
  // -----------------------------
  const onDragEnd = (result: DropResult) => {
    const { destination, source } = result;

    // If user drops outside or in the same position, do nothing
    if (!destination || destination.index === source.index) {
      return;
    }

    setColumnData((prev) => {
      if (!prev) return prev; // if null, just return
      // Reorder the array
      const reordered = reorder(prev, source.index, destination.index);

      // Update the Serial_No to match the new positions
      const updated = reordered.map((item, idx) => {
        return { ...item, Serial_No: idx + 1 };
      });
      return updated;
    });
  };

  const submit = () => {

    let Error_Lable = null;
    let Element: any = null
    if (!ColumnData) return;
    let updatedColumn = ColumnData.map((el) => {
      if (!el.Table_Column_Name) {
        Error_Lable = `Please Fill the ${el.Field_Label} Table Column Name `;
        Element = el
      }
      console.log(el, "elel")
      return {
        id: el._id,
        Table_ColumnManagement_Id: el?.Table_ColumnManagement_Id?._id,
        Status: el.Status || false,
        Serial_No: el.Serial_No,
        Field_Master_Id: el?.Licensee_FieldMaster_Id?._id,
        Table_Column_Name: el.Table_Column_Name,
        Column_Total: el?.Column_Total ? el?.Column_Total : false,
        Table_Id: el?.Table_Id,
        Field_Id: el?.Field_Id?._id,
      };
    });
    if (!Error_Lable) {

      UpdateOrder({
        variables: {
          userInput: updatedColumn,
          ApplyToAll,
          setDefault: defaultSettings,
          IsSuperAdminChange
        },
      })
        .then((res) => {
          SuccessToast("Fields updated successfully...!");
          dispatch({ type: "Refetch", payload: true });
          Closeformfunction();
        })
        .catch((err) => ErrorToast(err.message));
    } else {
      ErrorToast(Error_Lable);

      ErrorToast(Error_Lable);
      handleEditClick(Element);
    }
  };

  let formData = FormData;
  const SubmitEditColumn = () => {
    editTableColumn({
      variables: {
        id: selectedColumn?._id,
        userInput: formData,
      },
      // fetchPolicy: "no-cache",
    }).then((res) => {
      const resdata = res?.data?.editColumnManagementLabels;

      const updatedData = ColumnData.map((el) => {
        if (el._id === resdata?._id) {
          return {
            ...el,
            ...resdata,
          };
        } else return el;
      });
      setColumnData(updatedData);
      closeFormFunction();
    });
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  // Checkbox change for an individual column
  const handleChange = (evt, el: typeOfData) => {
    setColumnData((prev) => {
      if (!prev) return prev;
      return prev.map((element) => {
        if (el._id === element._id) {
          return { ...element, Status: evt.target.checked };
        }
        return element;
      });
    });
  };

  useEffect(() => {
    dispatch({ type: "ArrangeColumns", payload: ColumnData });
  }, [ColumnData]);

  const SaveAndClose = () => {
    submit();
  };

  const handleSelectAll = (e) => {
    setColumnData((prev) => {
      if (!prev) return prev;
      return prev.map((element) => {
        // If it's a Default column, leave it as is
        // if (element.Default) {
        //   return element;
        // }
        return { ...element, Status: e.target.checked };
      });
    });
  };

  useEffect(() => {
    myCounterRef.current = 0;
    ColumnData?.forEach((element: any) => {
      if (element.Status) {
        myCounterRef.current++;
      }
    });
  }, [ColumnData]);

  useEffect(() => {
    const GetUserRole = () => {
      getUserRole().then(({ Role }) => {
        setUserRoleAuth(Role === "Super Admin" || Role === "Super Access");
      });
    };
    GetUserRole();
  }, []);

  const handleDafaultSetting = () => {
    DefaultSetting({
      variables: {
        Table_Key: title || topModel,
      },
      fetchPolicy: "no-cache",
    })
      .then((res) => {
        setColumnData(res?.data?.Modify_Serial_No_To_Default_UserTableColumnManagement);
      })
      .catch((err) => ErrorToast(err.message));
  };

  const handleEditClick = async (column: typeOfData) => {
    const clone = column;
    console.log(clone, "cloneclonecloneclone")
    setSelectedColumn(clone);
    await setIsModalOpen(true);
    updateValueForm(formRef, clone);
  };

  const closeFormFunction = useCallback(() => {
    setIsModalOpen(false);
    setSelectedColumn(null);
    ClearSpecificForm(dispatch, Form_Key);
  }, []);

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => {
        submit();
      }}
      SaveAndClose={() => {
        SubmitEditColumn();
      }}
      handleformclose={() => {
        closeFormFunction();
      }}
      loadingState={tableColumnManagementLoading}
    />
  );

  return (
    <>
      <Reactportal open={show} onClose={Closeformfunction} TypeOfPortal={"View Setting"}>
        <div className="tableParent">
          <div className="SelectAllDiv" key={column.id}>
            <div>
              <div style={{ display: "inline-block", cursor: "auto" }}>
                <input
                  type="checkbox"
                  checked={ColumnData && ColumnData.length > 0 && myCounterRef.current === ColumnData.length}
                  onChange={(e) => handleSelectAll(e)}
                />
              </div>
              Column Name
            </div>
            <div>
              <div style={{ display: "inline-block", cursor: "auto" }}>
                <input
                  type="checkbox"
                  checked={defaultSettings}
                  onChange={(e) => setDefaultSettings(!defaultSettings)}
                />
              </div>
              Set as Default
            </div>
            {userRoleAuth && (
              <div>
                <div style={{ display: "inline-block", cursor: "auto" }}>
                  <input type="checkbox" checked={ApplyToAll} onChange={(e) => setApplyAll(e.target.checked)} />
                </div>
                Apply To All
              </div>
            )}
            {(
              <div>
                <div style={{ display: "inline-block", cursor: "auto" }}>
                  <input type="checkbox" checked={IsSuperAdminChange} onChange={(e) => setIsSuperAdminChange(e.target.checked)} />
                </div>
                Update Super ADM
              </div>
            )}
          </div>
          {!ColumnData?.length || DefaultLoading ? (
            <Loading />
          ) : (
            // ---------------
            // DragDropContext
            // ---------------
            <DragDropContext onDragEnd={onDragEnd}>
              {/* ------------------- */}
              {/* Single Droppable  */}
              {/* ------------------- */}
              <Droppable droppableId="columnsDroppable">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  // You can read snapshot.isDraggingOver if you want to style
                  // the droppable area differently when dragging over it
                  >
                    {ColumnData.map((column, index) => {
                      // Hide columns that are ID or not in Table_View
                      if (column?.Field_Id?.Field_Label?.toLowerCase() === "id" || column?.Table_View === false) {
                        return null;
                      }
                      return (
                        <Draggable key={column._id} draggableId={column._id} index={index}>
                          {(provided, snapshot) => (
                            <div
                              className={`tableRow-column-mangemenet dragdivbeautidaldnd ${snapshot.isDragging ? "column_dragging_modal" : ""
                                }`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            // You can read snapshot.isDragging if you want to style differently
                            >
                              {/* Column checkbox + label */}
                              <div className="checkbox-and-name">
                                <input
                                  type="checkbox"
                                  checked={!!column.Status}
                                  onChange={(e) => handleChange(e, column)}
                                />
                                <span>{column?.Table_Column_Name || column?.Field_Label}</span>
                              </div>

                              {/* Edit icon */}
                              <div className="InputEditIcon" role="button" onClick={() => handleEditClick(column)} >
                                <HiPencil className="icondown " id={column?.Field_Label} />
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}
        </div>

        <PortalFooter
          renderContent={() => (
            <>
              <Button action={() => setConifrmModalState(true)} name="modalbutton" text="Reset" />
            </>
          )}
          disabled={false}
          submitform={submit}
          SaveAndClose={SaveAndClose}
          handleformclose={Closeformfunction}
          loadingState={loading}
        />
      </Reactportal>

      {isModalOpen && selectedColumn && (
        <Reactportal
          FoooterContent={footerContent}
          open={true}
          onClose={closeFormFunction}
          TypeOfPortal={"Edit table column"}
        >
          {tableColumnManagementLoading && <div className="loader-line-div" />}
          <div className="formContainer">
            {getColumnFields(selectedColumn?.Table_ColumnManagement_Id?.Field_Type)?.map((section) => {
              return (
                <div key={section.id} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(section.name)}</div>
                  <div className="FormSection insidecontainer">
                    <FormInputSectionComponent
                      inputfields={section.fields}
                      Type={section.name}
                      validation_Schema={section.Valid_schema}
                      onhandleFormikChange={HanldeChangeonForm}
                      formkey={Form_Key}
                      formRef={formRef}
                    />
                  </div>
                </div>
              );
            })}

          </div>
        </Reactportal>
      )}
      {confirmModalstate && (
        <Confirm
          settoggle={setConifrmModalState}
          loadingState={false}
          toggle={confirmModalstate}
          submitType="Yes"
          submit={() => {
            handleDafaultSetting();
            setConifrmModalState(false);
          }}
          message={"Are You Sure You want change the current Column Labels and Sequence?ssss"}
        />
      )}
    </>
  );
};
